import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    accent: Palette["primary"];
    button: Palette["primary"];
    payment: {
      blueLight: string;
      greenLight: string;
      greenText: string;
      grayBorder: string;
      grayIconBg: string;
      check: string;
      muted: string;
      mutedFg: string;
    };
  }

  interface PaletteOptions {
    accent?: PaletteOptions["primary"];
    button?: PaletteOptions["primary"];
    error?: PaletteOptions["primary"];
    payment?: {
      blueLight?: string;
      greenLight?: string;
      greenText?: string;
      grayBorder?: string;
      grayIconBg?: string;
      check?: string;
      muted?: string;
      mutedFg?: string;
    };
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: "jaf-cupidus",
  },
  palette: {
    primary: {
      main: "#3e8bd2",
      light: "#3e8bd233",
    },
    secondary: {
      main: "#01214f",
      light: "#fff",
    },
    accent: {
      main: "#9ed642",
    },
    button: {
      main: "#ffffff",
      light: "#3E8BD2",
    },
    error: {
      main: "#f44336",
    },
    payment: {
      blueLight: "#E9F2FC",
      greenLight: "#E3F7E9",
      greenText: "#1E7B34",
      grayBorder: "#D7DEE8",
      grayIconBg: "#F8E9B6",
      check: "#E9D6F8",
      muted: "#F5F7FA",
      mutedFg: "#6B7280",
    },
  },
});
